import { Button, Col, Modal, Row, Typography } from "antd";
import {
  birthday2Age,
  convertIosStringToDate2,
  convertIosStringToDateDayjs,
  formatDateToString,
} from "helper/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import "./PrintComeHospital.scss";
import moment from "moment";
import { FORMAT_TIME } from "types/enums";
import BoxBHYT from "pages/Pay/PayTab/ModalPrintPTT/BoxBHYT/BoxBHYT";
import { Sign } from "components/common/PrintForm";
import { sharedDirectory } from "api";

const PrintComeHospital = React.forwardRef((props, ref) => {
  const printRef = useRef<any>();
  const [dataPhieu, setDataPhieu] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  useEffect(() => {
    if (dataPhieu) {
    }
  }, [dataPhieu]);
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setDataPhieu: setDataPhieu,
  }));

  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const onPrint = async () => {
    window.print();
  };
  // const style = {
  //   fontFamily: '"Times New Roman", Times, serif',
  // };
  const [danToc, setDanToc] = useState([]);
  const getListDanToc = async () => {
    try {
      let response = await sharedDirectory.getListDanToc();
      setDanToc(response.data.data);
    } catch (err) {}
  };

  useEffect(() => {
    getListDanToc();
  }, []);

  return (
    <div className="phieu-nhap-vien">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={960}
        destroyOnClose={true}
      >
        <div ref={printRef} className="print-content-phieu-vao-vien">
          <Row
            style={{
              padding: "20px 20px 25px 2.2cm",
              lineHeight: 1.5,
            }}
          >
            <Row>
              <Row justify={"space-between"}>
                <Col span={11}>
                  <Row
                    justify={"start"}
                    style={{
                      fontWeight: "bold",
                      fontSize: "12pt",
                      // fontFamily: style.fontFamily,
                    }}
                  >
                    BỘ Y TẾ
                  </Row>
                  <Row
                    style={{
                      fontWeight: "bold",
                      fontSize: "12pt",
                      // fontFamily: style.fontFamily,
                    }}
                    justify={"start"}
                  >
                    BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                  </Row>
                </Col>
                <Col span={7}></Col>
                <Col flex={"auto"}>
                  <Row justify={"start"}>MS: 04/BV-01</Row>
                  <Row>Số vào viện: {dataPhieu?.maPhieuKham} </Row>
                </Col>
              </Row>
              <Row
                justify={"center"}
                style={{
                  fontWeight: "bold",
                  padding: "17px 10px 0px",
                  fontSize: "24px",
                }}
              >
                <Row style={{ fontSize: "24px" }} justify={"center"}>
                  PHIẾU KHÁM BỆNH VÀO VIỆN
                </Row>
                <Row justify={"center"}>KHOA MẮT TỔNG HỢP</Row>
              </Row>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr style={{ height: "30px" }}></tr>
                </thead>
                <tbody style={{ paddingBottom: "15px" }}>
                  <Row style={{ fontWeight: "bold" }}>I.HÀNH CHÍNH:</Row>
                  <Row>
                    <Col span={12}>
                      1. Họ tên người bệnh:
                      <span style={{ fontWeight: "bold", paddingLeft: "5px" }}>
                        {dataPhieu?.tenBenhNhan?.toUpperCase()}
                      </span>
                    </Col>
                    <Col span={6}>
                      2. Sinh ngày:
                      {dataPhieu?.ngaySinh &&
                        formatDateToString(
                          convertIosStringToDateDayjs(dataPhieu?.ngaySinh)
                        )}
                    </Col>
                    <Col span={6}>
                      <Row justify={"center"}>
                        Tuổi: {birthday2Age(dataPhieu?.ngaySinh)}
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Row align={"middle"}>
                        3. Giới tính:&nbsp;
                        <span>1. Nam&nbsp;</span>
                        <label className="custom-checkbox">
                          <input
                            checked={dataPhieu?.gioiTinh === 0 ? true : false}
                            type="checkbox"
                          />
                          <span></span>
                        </label>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;2. Nữ&nbsp;</span>
                        <label className="custom-checkbox">
                          <input
                            checked={dataPhieu?.gioiTinh === 1 ? true : false}
                            type="checkbox"
                          />
                          <span></span>
                        </label>
                      </Row>
                    </Col>
                    <Col span={12}>4. Nghề nghiệp: {dataPhieu?.ngheNghiep}</Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      5. Dân tộc:{" "}
                      {danToc.find((e) => e.id === dataPhieu?.danToc)?.name}
                    </Col>
                    <Col span={12}>6. Ngoại kiều:</Col>
                  </Row>
                  <Row>7. Địa chỉ: {dataPhieu?.diaChi}</Row>
                  {/* <Row>8. Nơi làm việc: {dataPhieu?.noiLamViec}</Row> */}
                  <Row>8. Nơi làm việc: </Row>

                  <Row align={"middle"}>
                    9. Đối tượng:&nbsp;&nbsp;
                    <span>1. BHYT&nbsp;</span>
                    <label className="custom-checkbox">
                      <input
                        checked={dataPhieu?.soTheBaoHiemYTe ? true : false}
                        type="checkbox"
                        // checked={true}
                      />
                      <span></span>
                    </label>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;2. Thu phí&nbsp;</span>
                    <label className="custom-checkbox">
                      <input
                        // checked={false}
                        checked={!dataPhieu?.soTheBaoHiemYTe ? true : false}
                        type="checkbox"
                      />
                      <span></span>
                    </label>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;3. Miễn&nbsp;</span>
                    <label className="custom-checkbox">
                      <input checked={false} type="checkbox" />
                      <span></span>
                    </label>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;4. Khác&nbsp;</span>
                    <label className="custom-checkbox">
                      <input type="checkbox" checked={false} />
                      <span></span>
                    </label>
                  </Row>
                  <Row>
                    <Col span={10}>
                      10. BHYT có giá trị đến:&nbsp;
                      {convertIosStringToDate2(
                        dataPhieu?.bhytgiaTriDen
                      )?.format("DD/MM/YYYY")}
                    </Col>
                    <Col
                      span={14}
                      style={{ display: "flex", paddingTop: "4px" }}
                    >
                      Số thẻ BHYT:
                      <BoxBHYT code={dataPhieu?.soTheBaoHiemYTe ?? ""} />
                    </Col>
                  </Row>
                  <Row>
                    <Col flex={"auto"}>
                      11. Họ tên, địa chỉ người nhà khi cần báo tin:
                    </Col>
                    <Col span={6}>SĐT:</Col>
                  </Row>
                  {dataPhieu?.ngayNhapVien ? (
                    <Row>
                      <div>
                        12. Đến khám bệnh lúc:&nbsp;
                        {moment(dataPhieu?.ngayNhapVien).format(
                          "HH [giờ] mm [phút] , [ngày] DD [tháng] MM [năm] YYYY"
                        )}
                      </div>
                    </Row>
                  ) : (
                    <Row>
                      <Col>giờ</Col>
                      <Col>phút</Col>
                      <Col>giờ</Col>
                    </Row>
                  )}
                  <Row>
                    <div>
                      13. Chẩn đoán của nơi giới thiệu:&nbsp;
                      {dataPhieu?.chanDoanNoiGioiThieu ?? ""}
                    </div>
                    <div></div>
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>
                    II. LÝ DO VÀO VIỆN:&nbsp;{dataPhieu?.lyDoVaoVien ?? ""}
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>III. HỎI BỆNH:</Row>
                  <Row>
                    <Col span={15}>
                      <Row>
                        1. Quá trình bệnh lí:&nbsp;{dataPhieu?.benhSu ?? ""}
                      </Row>
                      <Row>
                        2.Tiền sử bệnh:
                        <Row style={{ paddingLeft: "15px" }}>
                          - Bản thân: {dataPhieu?.tienSuBenhBanThan}
                        </Row>
                        <Row style={{ paddingLeft: "15px" }}>
                          - Gia đình: {dataPhieu?.tienSuBenhGiaDinh}
                        </Row>
                      </Row>
                    </Col>
                    <Col span={9}>
                      <Row justify={"end"} style={{ paddingRight: "40px" }}>
                        <div
                          style={{
                            border: "1px solid #7e8a94",
                            borderRadius: "8px",
                            padding: "8px",
                            width: "200px",
                          }}
                        >
                          <Row justify={"space-between"}>
                            <Col className="font-style-italic">Mạch:</Col>
                            <Col>{dataPhieu?.mach ?? ""}</Col>
                            <Col className="font-style-italic">lần/phút</Col>
                          </Row>
                          <Row justify={"space-between"}>
                            <Col className="font-style-italic">Nhiệt độ:</Col>
                            <Col>{dataPhieu?.nhietDo ?? ""}</Col>
                            <Col className="font-style-italic">°C</Col>
                          </Row>
                          <Row justify={"space-between"}>
                            <Col className="font-style-italic">Huyết áp:</Col>
                            <Col>{dataPhieu?.huyetAp ?? ""}</Col>
                            <Col className="font-style-italic">mmHg</Col>
                          </Row>
                          <Row justify={"space-between"}>
                            <Col className="font-style-italic">Nhịp thở:</Col>
                            <Col>{dataPhieu?.nhipTho ?? ""}</Col>
                            <Col className="font-style-italic">lần/phút</Col>
                          </Row>
                          <Row justify={"space-between"}>
                            <Col className="font-style-italic">Cân nặng:</Col>
                            <Col>{dataPhieu?.canNang ?? ""}</Col>
                            <Col className="font-style-italic">kg</Col>
                          </Row>
                          <Row justify={"space-between"}>
                            <Col className="font-style-italic">Chiều cao:</Col>
                            <Col>{dataPhieu?.chieuCao ?? ""}</Col>
                            <Col className="font-style-italic">cm</Col>
                          </Row>
                        </div>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>IV. KHÁM XÉT:</Row>
                  <Row justify={"space-between"}>
                    <Col span={24}>
                      <Row>
                        <div>
                          1. Toàn thân: {dataPhieu?.khamXetToanThan ?? ""}
                        </div>
                      </Row>
                      <Row>
                        <div>
                          2. Các bộ phận:{" "}
                          {dataPhieu?.benhChuyenKhoa &&
                          dataPhieu?.benhChuyenKhoa !== ""
                            ? dataPhieu?.benhChuyenKhoa
                            : "Tim nhịp đều, phổi không rale"}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                  <Row>3. Tóm tắt kết quả lâm sàng: </Row>
                  {(dataPhieu?.khamMatMatPhai || dataPhieu?.khamMatMatTrai) && (
                    <Row>
                      <Typography.Text strong>- Khám mắt:</Typography.Text>
                    </Row>
                  )}
                  {(dataPhieu?.khamMatMatPhai || dataPhieu?.khamMatMatTrai) && (
                    <Row
                      style={{
                        // minHeight: "50px",
                        fontWeight: "bold",
                        marginBottom: "10px",
                        paddingLeft: "20px",
                      }}
                      gutter={[16, 25]}
                    >
                      {dataPhieu?.khamMatMatPhai && (
                        <Col span={12}>
                          <Row>
                            <Col flex={"40px"}>MP: </Col>
                            <Col flex={"auto"} style={{ fontWeight: "300" }}>
                              <div
                                className="html-text"
                                dangerouslySetInnerHTML={{
                                  __html: dataPhieu?.khamMatMatPhai,
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      )}
                      {dataPhieu?.khamMatMatTrai && (
                        <Col span={12}>
                          <Row>
                            <Col flex={"40px"}>MT: </Col>
                            <Col flex={"auto"} style={{ fontWeight: "300" }}>
                              <div
                                className="html-text"
                                dangerouslySetInnerHTML={{
                                  __html: dataPhieu?.khamMatMatTrai,
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  )}
                  {(dataPhieu?.thiLucKhongKinhMatPhai ||
                    dataPhieu?.thiLucKhongKinhMatTrai) && (
                    <Row>
                      <Typography.Text strong>
                        - Thị lực không kính:
                      </Typography.Text>
                    </Row>
                  )}

                  {(dataPhieu?.thiLucKhongKinhMatPhai ||
                    dataPhieu?.thiLucKhongKinhMatTrai) && (
                    <Row
                      style={{
                        fontWeight: "bold",
                        paddingLeft: "20px",
                        marginBottom: "10px",
                      }}
                    >
                      {dataPhieu?.thiLucKhongKinhMatPhai && (
                        <Col span={12}>
                          <Row gutter={8}>
                            <Col>MP:</Col>
                            <Col style={{ fontWeight: "normal" }}>
                              {dataPhieu?.thiLucKhongKinhMatPhai}
                            </Col>
                          </Row>
                        </Col>
                      )}
                      {dataPhieu?.thiLucKhongKinhMatTrai && (
                        <Col span={12}>
                          <Row gutter={8}>
                            <Col>MT:</Col>
                            <Col style={{ fontWeight: "normal" }}>
                              {dataPhieu?.thiLucKhongKinhMatTrai}
                            </Col>
                          </Row>
                        </Col>
                      )}

                      {/* </Col> */}
                      {/* <Col span={10}>
                      <Row>
                        <Col span={6}>Nhãn áp:</Col>
                        <Col flex={"auto"}>
                          <Row gutter={8}>
                            <Col>MP:</Col>
                            <Col style={{ fontWeight: "normal" }}>
                              {dataPhieu?.nhanApMatPhai}
                            </Col>
                          </Row>
                          <Row gutter={8}>
                            <Col>MT:</Col>
                            <Col style={{ fontWeight: "normal" }}>
                              {dataPhieu?.nhanApMatTrai}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col> */}
                    </Row>
                  )}
                  {(dataPhieu?.thiLucCoKinhMatPhai ||
                    dataPhieu?.thiLucCoKinhMatTrai) && (
                    <Row>
                      <Typography.Text strong>
                        - Thị lực có kính:
                      </Typography.Text>
                    </Row>
                  )}

                  <Row style={{ fontWeight: "bold", paddingLeft: "20px" }}>
                    {dataPhieu?.thiLucCoKinhMatPhai && (
                      <Col span={12}>
                        <Row gutter={8}>
                          <Col>MP:</Col>
                          <Col style={{ fontWeight: "normal" }}>
                            {dataPhieu?.thiLucCoKinhMatPhai}
                          </Col>
                        </Row>
                      </Col>
                    )}
                    {dataPhieu?.thiLucCoKinhMatTrai && (
                      <Col span={12}>
                        <Row gutter={12}>
                          <Col>MT:</Col>
                          <Col style={{ fontWeight: "normal" }}>
                            {dataPhieu?.thiLucCoKinhMatTrai}
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>

                  <Row>
                    4. Chẩn đoán vào viện:{" "}
                    {(dataPhieu?.icdChanDoan
                      ? dataPhieu?.icdChanDoan + " - "
                      : "") + (dataPhieu?.chanDoan ?? "")}
                  </Row>
                  <Row>
                    5. Đã xử lí (thuốc, chăm sóc...): {dataPhieu?.daXuLy ?? ""}
                  </Row>
                  <Row>
                    6. Cho vào điều trị tại khoa:{" "}
                    <span style={{ fontWeight: "bold", paddingLeft: "5px" }}>
                      Khoa Mắt tổng hợp
                    </span>
                  </Row>
                  <Row>7. Chú ý: </Row>
                </tbody>
                {/* <tfoot>
                </tfoot> */}
              </table>
            </Row>

            <Row justify={"space-around"} style={{ paddingTop: "15px" }}>
              <Sign
                nguoiThucHien={dataPhieu?.tenBacSiDieuTri ?? ""}
                label="Bác sĩ khám bệnh"
                time={dataPhieu?.ngayNhapVien}
              />
            </Row>
          </Row>
        </div>

        <Row justify={"end"} gutter={[16, 16]}>
          {/* <Space direction="horizontal"> */}
          <Col>
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
          </Col>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="print-content-phieu-vao-vien"
            // onAfterPrint={closeModal}
          />
        </Row>
      </Modal>
    </div>
  );
});

export default PrintComeHospital;
